export enum SurchargesEnum {
  FUEL = 'fuel',
  RZO = 'rzo',
  HIGH = 'high',
  PEAK = 'peak',
  ESA = 'esa',
  EVENT = 'event'
}